import type { MaybeRef } from '@vueuse/core'
import type { AsyncDataOptions } from 'nuxt/dist/app/composables/asyncData'

export function useAPI<T>(getMethod: () => Promise<T>, options?: AsyncDataOptions<T>) {
  return useAsyncData(
    randomID(),
    getMethod,
    options,
  )
}

export function useParseQuery<T extends Record<string, MaybeRef<any>>>(
  url: string,
  query?: T,
) {
  if (!query)
    return url

  const parsedQueries = Object.entries(query)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => [key, String(unref(value))])

  const fullQuery = new URLSearchParams(parsedQueries.filter(query => query[1] !== undefined))

  return `${url}?${fullQuery.toString()}`
}
